import { IDirective } from 'angular';
import { Subscription } from 'rxjs';
import { fromEvent } from 'rxjs/observable/fromEvent';
import './image-zoom.directive.scss';

export function imageZoom(): IDirective {
  return {
    restrict: 'A',
    scope: {
      zoomSrc: '=zoomSrc',
    },
    link: ($scope: any, $element) => {
      console.log('test Work');
      $element.on('click', (event) => {
        console.log('clicked');
        const imgBlock = document.createElement('div');
        imgBlock.className = 'img-preview-fullScreen';
        const image: HTMLImageElement = document.createElement('img');
        image.src = $scope.zoomSrc;
        const closeBtn = document.createElement('button');
        closeBtn.className = 'btn btn-red close-btn';
        closeBtn.innerText = 'Close';
        imgBlock.appendChild(closeBtn);
        setTimeout(() => {
          image.classList.add('active1x');
        }, 200);
        document.body.appendChild(imgBlock).appendChild(image);
        const zoom: Subscription = fromEvent(image, 'click').subscribe((res) => {
          image.classList.toggle('active2x');
        });
        const close: Subscription = fromEvent(closeBtn, 'click').subscribe(
          (res) => {
              zoom.unsubscribe();
              close.unsubscribe();
              image.className = '';
              setTimeout(() => {
                imgBlock.remove();
              }, 350);
          }
        );
      });
    }
  };
}

imageZoom.$inject = [];



// WEBPACK FOOTER //
// ./app/shared/directives/image-zoom/image-zoom.directive.ts